import {
  Datagrid, List, TextField, NumberField, EditButton, Edit, Create, SimpleForm,
  TextInput, NumberInput, required,
} from 'react-admin';
import { Stack, Typography, Box } from '@mui/material';
import StarIcon from '@mui/icons-material/AutoAwesome';
import { ImageUploadInput } from '../../components/ImageUploadInput.jsx';

const FeatureList = () => (
  <List sort={{ field: 'sortOrder', order: 'ASC' }} perPage={25}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="number" />
      <TextField source="title" />
      <NumberField source="sortOrder" label="Order" />
      <EditButton />
    </Datagrid>
  </List>
);

const FeatureForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 720 }}>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextInput
        source="number"
        label='Number (e.g. "01")'
        validate={required()}
        sx={{ width: 160 }}
        helperText="Two-digit accent shown in the title bar."
      />
      <TextInput source="title" label="Title" validate={required()} fullWidth />
    </Stack>

    <TextInput
      source="description"
      label="Description"
      multiline
      minRows={4}
      fullWidth
      validate={required()}
    />

    <ImageUploadInput
      source="image"
      label="Panel image"
    />

    <TextInput
      source="readMore"
      label='Read more link (optional)'
      fullWidth
      helperText='Where the "Read More" link inside the panel points. Use a relative path (e.g. "/alumni", "/page/principals-message") or a full URL. Leave blank to hide the link.'
    />

    <NumberInput source="sortOrder" label="Sort order" defaultValue={0} />

    <Box sx={{ background: 'var(--cream, #faf6ec)', border: '1px dashed var(--line, #e6e1d4)', borderRadius: 1, p: 1.5, mt: 1 }}>
      <Typography variant="caption" sx={{ color: 'var(--ink-3, #5d6660)' }}>
        <strong>Layout:</strong> these features render as a horizontal
        accordion on the homepage. The 5 design icons (bookshelf,
        people, chalkboard, medal, open book) are mapped by position
        — feature #1 gets the bookshelf icon, #5 gets the open book.
        Reordering features reorders the icons too.
      </Typography>
    </Box>
  </Stack>
);

const FeatureEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><FeatureForm /></SimpleForm>
  </Edit>
);
const FeatureCreate = () => (
  <Create redirect="list">
    <SimpleForm><FeatureForm /></SimpleForm>
  </Create>
);

export default {
  list: FeatureList,
  edit: FeatureEdit,
  create: FeatureCreate,
  icon: StarIcon,
  options: { label: 'Why Maple Leaf' },
};
